module.exports = __webpack_public_path__ + "img/dial.7763b44f.png";